import { Avatar } from "app/components/avatar/avatar";
import { FadeInSlide } from "app/motions/fadeInSlide";
import * as React from "react";

export const DailyResourceHeader: React.FC<any> = ({ resource }) => {



  return (
    <FadeInSlide
      direction="top"
      className="flex items-center justify-between w-full -translate-x-1 p-2 z-10"
      delay={1}
    >
      <div
        key={resource.resourceId}
        className="flex justify-center items-center w-full mx-2 min-w-0"
      >
        {/*<Avatar src={resource.avatar} name={resource.resourceTitle} size={24} />*/}
        <p className="ml-2 text-sm font-semibold truncate">
          {resource.resourceTitle}
        </p>
      </div>
    </FadeInSlide>
  );
};
